import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSelectModule} from '@angular/material/select';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {HttpClientModule} from '@angular/common/http';
import {ToastrModule} from 'ngx-toastr';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatExpansionModule} from '@angular/material/expansion';
import {CooperationInvitationResponseComponent} from './cooperation-invitation-response.component';
import {CoopemployeeNamePipe} from './employee-name.pipe';

@NgModule({
  declarations: [
    CooperationInvitationResponseComponent,
    CoopemployeeNamePipe
  ],
  imports: [
    CommonModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatSelectModule,
    HttpClientModule,
    MatMenuModule,
    MatIconModule,
    ToastrModule.forRoot(
      {
        maxOpened: 5,
        preventDuplicates: true,
        countDuplicates: true,
        timeOut: 5000,
        extendedTimeOut: 8000,
        progressBar: true
      }
    ),
    MatToolbarModule,
    MatExpansionModule,
    MatIconModule,
  ],
  exports: [
    CooperationInvitationResponseComponent
  ],
})
export class CooperationInvitationModule {
}
